// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"ba7bc2f6","158":"2508e74f","238":"fde470f2","667":"9233fcb5","771":"283eff81","809":"a6ab1215","913":"3fa44aef","997":"6dfa4858"}[chunkId] + ".chunk.js";
};